<template>
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 13V8.4C20 6.15979 20 5.03968 19.564 4.18404C19.1805 3.43139 18.5686 2.81947 17.816 2.43597C16.9603 2 15.8402 2 13.6 2H8.4C6.15979 2 5.03968 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404C2.10205 4.8394 2.02389 5.6499 2.00559 7M13 20H8.4C6.15979 20 5.03968 20 4.18404 19.564C3.43139 19.1805 2.81947 18.5686 2.43597 17.816C2 16.9603 2 15.8402 2 13.6V8.4C2 7.87562 2 7.41261 2.00559 7M2.00559 7L7.6 12.5M7.6 12.5L8.7833 10.9358C9.54827 9.92461 9.93075 9.41901 10.4113 9.20982C10.8331 9.02618 11.3054 8.9936 11.7485 9.11758C12.2532 9.2588 12.7015 9.70708 13.5981 10.6037L16 13.0056M7.6 12.5L13 17.9M16.01 6H15.99" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <path d="M19 16V19M19 19V22M19 19H22M19 19H16" stroke="white" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<script>

export default {
  name: 'addImgIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
